import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { User } from 'src/app/core/models';
import { StorageKey, StorageService } from 'src/app/core/services';
import { AdministrativeService } from 'src/app/core/services/administrative.service';
import { VerifyPermissionUrl } from '../utils/verify-permission-url';

@Component({
  selector: 'app-manage-module',
  templateUrl: './manage-module.component.html',
  styleUrls: ['./manage-module.component.sass']
})
export class ManageModuleComponent implements OnInit {

  public searchForm: FormGroup;
  public viewModes = { user: 'user', permission: 'permission' };
  public viewMode = this.viewModes.user;
  public loading = false;
  public users: User[] = [];
  public usersData: User[] = [];
  public currentUser: User;
  public permissions = [];
  public params: any = {};

  constructor(
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    public administrativeService: AdministrativeService,
    private verifyPermissionUrl: VerifyPermissionUrl
  ) { }

  async ngOnInit() {
    this.verifyPermissionUrl.execute(['ManageModule']);
    this.loading = true;
    this.setParams();
    this.createSearchForm();
    this.getCurrentUser();
    await this.getUsers();
    this.loading = false;
  }

  async getUsers() {
    const result = await this.administrativeService.paginate({
      page: 1,
      pageSize: 1000,
      limit: 1000,
      ...this.params
    }, 'list');
    this.usersData = result.data;
  }

  getCurrentUser() {
    this.currentUser = this.storageService.get(StorageKey.currentUser);
  }

  setParams() {
    this.params.page = 1;
    this.params.pageSize = 1000;
    this.params.limit = 1000;
  }

  createSearchForm() {
    this.searchForm = this.formBuilder.group({
      search: ['']
    });
    this.searchForm.get('search').valueChanges.subscribe(value => {
      this.handleSearch(value);
    });
  };

  setViewMode(value: string) {
    this.viewMode = value;
  }

  async handleSearch(value: string) {
    let search = {};
    if (value.includes('@')) {
      search = { 'email[like]': `[%${value}%]` };
    } else {
      search = { 'name[like]': `[%${value}%]` };
    }
    this.params = { ...search };
    await this.getUsers();
  }

  setUsers(event) {
    this.users = event.data;
    this.permissions = this.getGroupUsersByPermissionArray(this.users);
  }

  setUsersDara(event) {
    this.users = event;
    this.permissions = this.getGroupUsersByPermissionArray(this.users);
  }

  groupUsersByPermission(items) {
    const result: any = {};

    for (const user of items) {
      for (const perm of user.UserAdminPermissions) {
        const relationId = perm.id;
        const permId = perm.AdminPermission.id;
        const permName = perm.AdminPermission.name;

        if (!result[permName]) {
          result[permName] = {
            permissionId: permId,
            users: []
          };
        }

        result[permName].users.push({
          id: user.id,
          relationId,
          name: user.name,
          email: user.email
        });
      }
    }

    return result;
  }

  getGroupUsersByPermissionArray(data) {
    const map = this.groupUsersByPermission(data);
    return Object.entries(map).map(([name, content]) => ({ name, content }));
  }

}
